
import {
	SET_DEPARTMENTS,
	SET_DEPARTMENT,
	SET_SEARCH_FILTERS,
	SET_LOADING,
	SET_PLANS,
	SET_META,
	SET_PARTNERSHIPS,
	SET_CURRENCIES,
	SET_COUNTRIES,
	SET_VACATION,
	SET_LAST_VACATION
} from './mutation-types'

export default {
	[SET_DEPARTMENTS] (state, departments) {
		if (!departments || !departments.length) {
			state.meta = {}
		}
		state.data = departments
	},
	[SET_DEPARTMENT] (state, department) {
		state.department = department
	},
	[SET_CURRENCIES] (state, currencies) {
		state.currencies = currencies
	},
	[SET_COUNTRIES] (state, countries) {
		state.countries = countries
	},
	[SET_PLANS] (state, plans) {
		state.plans = plans
	},
	[SET_META] (state, meta) {
		state.meta = meta
	},
	[SET_SEARCH_FILTERS] (state, searchFilters) {
		state.searchFilters = searchFilters
	},
	[SET_LOADING] (state, loading) {
		state.loading = { ...state.loading, ...loading }
	},
	[SET_PARTNERSHIPS] (state, partnerships) {
		state.partnerships = partnerships
	},
	[SET_VACATION] (state, vacation) {
		state.vacation = vacation
	},
	[SET_LAST_VACATION] (state, vacation) {
		state.lastVacation = vacation
	}
}
